module.exports = __webpack_public_path__ + "img/euroloan.7f558cb.png";